module.exports = __webpack_public_path__ + "static/ornament-01-1b8fd5d5d1fe7b35f423c5b2781f060d.png";